<template>
  <div v-if="currentModel?.tplName" class="container">
    <!-- 面包屑: -->
    <Breadcrumb :items="[currentModel?.title || '']" />
    <!-- 内容: -->
    <component
      :is="componentMap[currentModel.tplName]"
      :cms-model="currentModel"
    />
  </div>
</template>

<script lang="ts" setup>
  import { defineAsyncComponent, onMounted } from 'vue';
  import { useRoute, useRouter } from 'vue-router';
  import { useModelStore } from '@/store';
  import { Message } from '@arco-design/web-vue';
  import { ModelState } from '@/store/modules/cms/types';
  import { getDefineModelByName } from './model';

  // 0、异步加载组件
  const componentMap = {
    list: defineAsyncComponent(() => import('./curd/index.vue')),
    single: defineAsyncComponent(() => import('./single/index.vue')),
  };

  // 1.取model内容
  const modelStore = useModelStore();
  const route = useRoute();
  const router = useRouter();
  const modelName = (route.params.model || route.name) as string;
  let currentModel: ModelState | undefined =
    modelStore.getModelByName(modelName);
  if (1 || !currentModel?.name) {
    currentModel = getDefineModelByName(modelName);
  }
  onMounted(() => {
    if (!currentModel?.tplName) {
      Message.error({ content: `${modelName}不存在`, id: 'model_not_exist' });
      router.push({ name: 'dashboard' });
    }
  });
</script>

<style scoped>
  .container {
    padding: 0 20px 20px 20px;
  }
</style>
